/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import CreateBot from "./features/createbot";

const BotIntegration = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <CreateBot/>
        </section>
      </Layout>
    </>
  );
};
export default BotIntegration;
